'use strict'

import angular from 'angular';

angular.module('buySheet.services', []).factory('BuySheetService', BuySheetService)

/**
 * @ngInject
 */
function BuySheetService(IORestangular) {
    return {
        getBuySheetTemplates() {
            return IORestangular.all('buySheets').customGET()
        },
        getBuySheet(orderId, buySheetTemplateId) {
            return IORestangular.all('buySheets/show').customGET(undefined, {order_id: orderId, buy_sheet_template_id: buySheetTemplateId})
        },
        regenerate(buySheetId) {
            return IORestangular.all('buySheetRegenerations').customPOST({buy_sheet_regeneration: {previous_buy_sheet_id: buySheetId}})
        },
        exportToPdf(buySheetId, elementHtml) {
            return IORestangular.all('buySheetPdfs')
                .withHttpConfig({responseType: 'blob'})
                .customPOST(
                    {buy_sheet: {id: buySheetId, element: elementHtml}},
                'create'
            )
        },
        exportToXlsx(orderId) {
            return IORestangular.withConfig(function (RestangularConfigurer) {
                RestangularConfigurer.setFullResponse(true);
            }).all('buySheetXlsxSpreadsheets')
                .withHttpConfig({responseType: 'blob'})
                .customPOST(
                    {order_id: orderId},
                    'create'
                )
        }
    }
}